<h3>{{data.title | translate}}</h3>

<div class="inputEditForm">
    <mat-form-field appearance="outline">
        <mat-label>{{ data.campo | translate }}</mat-label>
        <input matInput [(ngModel)]="data.value"/>
    </mat-form-field> 
</div>

<button mat-raised-button [mat-dialog-close]>{{'DASHBOARD.EDIT_WIDGET.CANCEL' | translate}}</button>
<button mat-raised-button color="primary" class="right" 
    [mat-dialog-close]="data.value" cdkFocusInitial>{{'DASHBOARD.EDIT_WIDGET.ACCEPT' | translate}}</button>